// src/core/useBranding.ts
import { useEffect, useMemo, useState } from "react";
import { applyBranding, getBrand, type Brand } from "./brand";
import { THEME_CHANGED_EVENT, readBootTheme, readCurrentTheme, type Theme } from "./theme";

export function useBranding(): Brand {
  const brand = useMemo(() => getBrand(), []);
  const [theme, setTheme] = useState<Theme | null>(() => readCurrentTheme() ?? readBootTheme());

  useEffect(() => {
    applyBranding(brand);
  }, [brand]);

  useEffect(() => {
    function onThemeChanged(e: Event) {
      const ce = e as CustomEvent<{ theme?: Theme }>;
      const next = ce.detail?.theme;
      if (next === "day" || next === "night") setTheme(next);
    }

    window.addEventListener(THEME_CHANGED_EVENT, onThemeChanged as EventListener);
    return () => window.removeEventListener(THEME_CHANGED_EVENT, onThemeChanged as EventListener);
  }, []);

  return useMemo(
    () => ({
      ...brand,
      logoSrc32: theme === "night" ? brand.logoSrcNight : brand.logoSrcDay,
    }),
    [brand, theme]
  );
}
